import axios from 'axios'
import {Loading} from 'element-ui'
import store from '@/store'

let loadingService
let reqNum = 0
// create an axios instance
const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 1 * 60 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers['token'] = store.state.token
        }
        if (config.loading !== false) {
            startLoading()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(response => {
        endLoading()
        return response
    },
    error => {
        endLoading()
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

export default service

/* 开始动画*/
function startLoading() {
    if (reqNum === 0) {
        loadingService = Loading.service({fullscreen: true, background: 'rgba(255,255,255,0)', text: '数据加载中...'})
    }
    reqNum++
}

// 延迟 300ms 再调用 closeLoading 方法，合并300ms内的请求
function endLoading() {
    setTimeout(closeLoading, 300)
}

/* 结束动画*/
function closeLoading() {
    if (reqNum <= 0) return
    reqNum--
    if (reqNum === 0) {
        loadingService.close()
    }
}
